// Constants for storage keys
const TOKEN_KEY = 'auth_token';
const PASSPHRASE_KEY = 'passphrase'; // Now stores derived key (non-reversible)

export class StorageHelper {
  // Token management
  static setToken(token: string): void {
    localStorage.setItem(TOKEN_KEY, token);
  }

  static getToken(): string | null {
    return localStorage.getItem(TOKEN_KEY);
  }

  static removeToken(): void {
    localStorage.removeItem(TOKEN_KEY);
  }

  // Passphrase management (stores secure derived key)
  static setPassphrase(passphraseKey: string, rememberPassphrase: boolean = false): void {
    // Always store in session storage for current session
    sessionStorage.setItem(PASSPHRASE_KEY, passphraseKey);
    
    if (rememberPassphrase) {
      // If user explicitly opts in to remember passphrase across sessions
      localStorage.setItem(PASSPHRASE_KEY, passphraseKey);
    } else {
      // Ensure it's not in localStorage if not requested
      localStorage.removeItem(PASSPHRASE_KEY);
    }
  }
  
  static getPassphrase(): string | null {
    // Try session storage first
    let passphrase = sessionStorage.getItem(PASSPHRASE_KEY);
    
    // If not found, try local storage
    if (!passphrase) {
      passphrase = localStorage.getItem(PASSPHRASE_KEY);
    }
    
    return passphrase;
  }
  
  static clearPassphrase(): void {
    sessionStorage.removeItem(PASSPHRASE_KEY);
    localStorage.removeItem(PASSPHRASE_KEY);
  }

  // Clear all auth data
  static clearAuthData(): void {
    localStorage.removeItem(TOKEN_KEY);
    this.clearPassphrase();
  }

  // Check if user is authenticated
  static isAuthenticated(): boolean {
    return !!this.getToken();
  }
}